import { FETCH_BATCH_ORDERS_COUNT_REQUEST, FETCH_BATCH_ORDERS_COUNT_SUCCESS, FETCH_BATCH_ORDERS_COUNT_FAILURE, FETCH_BATCH_ORDERS_COUNT_REST } from "../../actions";
const initialState = {
    fetchOrdersCount: null,
    isLoading: false,
    error: null,
};
const BatchOrderCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BATCH_ORDERS_COUNT_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case FETCH_BATCH_ORDERS_COUNT_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchOrdersCount: action.payload, isLoading: false, error: null });
        case FETCH_BATCH_ORDERS_COUNT_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case FETCH_BATCH_ORDERS_COUNT_REST:
            return initialState;
        default:
            return state;
    }
};
export default BatchOrderCountReducer;
